/**
 * Aspect — Active apartment plan (browser localStorage)
 * --------------------------------------------------------------
 * Mirrors the server-side saved plan so the analysis panel and 3D viewport
 * stay in sync after a page refresh even before the orchestrator responds.
 */

const STORAGE_KEY = "aspect-active-plan";

/** @returns {{ spec: object, summary?: string, confidence?: string, source?: string } | null} */
export function loadSavedPlan() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data?.spec || typeof data.spec !== "object") return null;
    return data;
  } catch {
    return null;
  }
}

/** @param {{ spec: object, summary?: string, confidence?: string, source?: string }} record */
export function saveSavedPlan(record) {
  if (!record?.spec) return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
}

export function clearSavedPlan() {
  localStorage.removeItem(STORAGE_KEY);
}

export default { loadSavedPlan, saveSavedPlan, clearSavedPlan };
